import { ProfileIcon } from "@packages/ui/components";
import { faAngleLeft, faBars, faChevronDown } from "@packages/ui/libs";
import { useData } from "@providers/context";
import {
  Drawer,
  FontAwesomeIcon,
  IconButton,
  ListItemText,
  Menu,
  MenuItem,
  MuiAppBar,
  MuiAppBarProps,
  Toolbar,
  VeBox,
  VeTypography,
  styled,
  useMediaQuery,
} from "@packages/ui/mui";
import {
  VE_TEXTICON,
  PROFILE_ACTIVE,
  SETTINGS,
  LOGOUT,
  HELP,
  BELL_ICON,
  PROFILE_DETAILS,
  TEAMS_UNSELECTED,
  BELL_ICON_ACTIVE,
  REFRESH,
  VE_SELLER,
  DASHBOARD_ICON,
  ACCOUNT_SETTINGS,
  LINK_GREY,
} from "@public/index";
import { signOut } from "next-auth/react";
import Image from "next/image";
import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import React, { useEffect, useState } from "react";
import RoleSelector from "./RoleSelector";
import ProjectSelector from "./ProjectSelector";
import SelectRoleModal from "@components/AuthModals.tsx/SelectRoleModal";
import AppDropdown from "./AppDropdown";
import SettingsDropdown from "./SettingsDropdown";
import SettingsIcon from "@components/SvgComponents/SettingsIcon";
import AppsIcon from "@components/SvgComponents/AppsIcon";
import { LimiterToolTip } from "@components/shared/ToolTipBadge";
import { clearLocalStorageExcept } from "@libs/helper";

const roles = {
  INVESTOR: "Investor",
  SELLER: "Project Developer",
  PROJECT_REVIEWER: "Verifier",
  SALES_PARTNER: "Sales Partner",
};

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const StyledAppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop: any) => prop !== "open",
})<AppBarProps>(({ theme, open }: any) => ({
  zIndex: 100,
  width: `auto`,
  boxShadow: "none !important",
  left: 0,
  borderBottom: "1px solid",
  borderWidth: "0.5px",
  borderColor: "#E8E8E8",
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    boxShadow: "none !important",
    left: "auto",
    borderBottom: "1px solid",
    borderWidth: "0.5px",
    borderColor: "#E8E8E8",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

// box-shadow: 0px 8px 16px -6px rgba(0, 0, 0, 0.08);

// box-shadow: 0px 6px 8px -6px rgba(0, 0, 0, 0.12);

function AppBarUser({
  data,
  open,
  handleDrawerToggle,
  anchorElUserTab,
  handleCloseUserMenuTab,
  handleOpenUserMenuTab,
}: {
  open?: any;
  data?: any;
  handleDrawerToggle: any;
  anchorElUserTab: any;
  handleCloseUserMenuTab: any;
  handleOpenUserMenuTab: any;
}) {
  const router = useRouter();
  const isMobile = useMediaQuery("(max-width: 600px)");
  const isTab = useMediaQuery("(max-width: 900px)");
  const isXL = useMediaQuery("(min-width: 2200px)");
  const [menuHover, setMenuHover] = useState(false);
  const [selectRoleModal, setSelectRoleModal] = useState(false);
  const drawerWidth = 250;
  const { headerData } = useData();
  const pathName = usePathname();

  const { currentRole, userData } = useData();

  const sellerDashBoardCondition = pathName === "/dashboard";
  const orgId = userData?.user?.organisationId || "";
  interface ProfileItemData {
    label: string;
    path?: string;
    icon?: JSX.Element;
    selectedPath?: string;
    click?: () => void;
  }

  const oldSettings = [
    {
      name: "Profile",
      onClick: () => {
        router.push("/setting-profile?section=0");
        handleCloseUserMenuTab();
      },
      path: "/setting-profile?section=0",
      icon: <Image src={PROFILE_DETAILS} alt="profile" />,
      iconActive: <Image src={PROFILE_ACTIVE} alt="profile" />,
    },
    {
      name: "Account Settings",
      onClick: () => {
        router.push("/settings/account");
        handleCloseUserMenuTab();
      },
      path: "/settings/account",
      icon: <Image src={SETTINGS} alt="profile" />,
    },
    {
      name: "Settings",
      onClick: () => {
        router.push("/setting-profile?section=2");
        handleCloseUserMenuTab();
      },
      path: "/setting-profile?section=2",
      icon: <Image src={SETTINGS} alt="profile" />,
    },

    {
      name: "Logout",
      onClick: () => {
        clearLocalStorageExcept();
        sessionStorage.clear();
        signOut();
        handleCloseUserMenuTab();
      },
      icon: <Image src={LOGOUT} alt="LOGOUT" />,
    },
  ];

  const settings = [
    {
      name: "Profile",
      onClick: () => {
        router.push("/profile");
        handleCloseUserMenuTab();
      },
      path: "/profile",
      icon: <Image src={PROFILE_DETAILS} alt="profile" />,
      iconActive: <Image src={PROFILE_ACTIVE} alt="profile" />,
    },
    {
      name: "Account Settings",
      onClick: () => {
        router.push("/settings/account");
        handleCloseUserMenuTab();
      },
      path: "/settings/account",
      icon: <Image src={ACCOUNT_SETTINGS} alt="profile" />,
    },

    { devider: true },
    ...(userData?.user?.internalRoleName?.length > 1
      ? [
          {
            name: "Switch Roles",
            onClick: () => {
              setSelectRoleModal(true);
              handleCloseUserMenuTab();
            },
            icon: <Image src={REFRESH} alt="teams" height={20} width={20} />,
          },
        ]
      : []),
    {
      name: "Logout",
      onClick: () => {
        clearLocalStorageExcept();
        sessionStorage.clear();
        signOut();
        handleCloseUserMenuTab();
      },
      icon: <Image src={LOGOUT} alt="LOGOUT" />,
    },
  ];
  const tabSettings: any = [
    {
      name: "Profile",
      onClick: () => {
        router.push("/profile");
        handleCloseUserMenuTab();
      },
      path: "/profile",
      icon: <Image src={PROFILE_DETAILS} alt="profile" />,
      iconActive: <Image src={PROFILE_ACTIVE} alt="profile" />,
    },
    {
      name: "Account Settings",
      onClick: () => {
        router.push("/settings/account");
        handleCloseUserMenuTab();
      },
      path: "/settings/account",
      icon: <Image src={ACCOUNT_SETTINGS} alt="profile" />,
    },

    { devider: true },
    ...(isMobile
      ? [
          {
            name: "Vericap Settings",
            icon: <Image src={SETTINGS} alt="profile" />,
            items: [
              {
                label: "General Settings",
                onClick: () => {
                  // Add navigation logic
                  router.push("/settings/general");
                  handleCloseUserMenuTab();
                },
              },
              {
                label: "User Management",
                onClick: () => {
                  window.open(`/admin/${orgId}/users`);
                },
                newTab: true,
              },
              {
                label: "Organisation Settings",
                onClick: () => {
                  window.open(`/admin/${orgId}/overview`);
                },
                newTab: true,
              },
            ],
          },
          ...(currentRole === "SELLER"
            ? [
                {
                  name: "Apps",
                  icon: <Image src={DASHBOARD_ICON} alt="profile" />,
                  items: [
                    {
                      label: "My Projects",
                      onClick: () => {
                        window.open("/apps/all-projects");
                      },
                    },
                    {
                      label: "Credit Analytics",
                      onClick: () => {
                        window.open("/apps/analytics/carbon/overview");
                      },
                    },
                  ],
                },
              ]
            : []),
          {
            name: "Help",
            href: `mailto:support@vericap.io?subject=Support Request - (${data?.user?.orgIndex})`,
            onClick: () => {
              // router.push("/setting-profile?section=0");
              handleCloseUserMenuTab();
            },
            icon: <Image src={HELP} alt="help" />,
          },
          { devider: true },
        ]
      : []),
    ...(userData?.user?.internalRoleName?.length > 1
      ? [
          {
            name: "Switch Roles",
            onClick: () => {
              setSelectRoleModal(true);
              handleCloseUserMenuTab();
            },
            icon: <Image src={REFRESH} alt="teams" height={20} width={20} />,
          },
        ]
      : []),
    {
      name: "Logout",
      onClick: () => {
        clearLocalStorageExcept();
        sessionStorage.clear();
        signOut();
        handleCloseUserMenuTab();
      },
      icon: <Image src={LOGOUT} alt="LOGOUT" />,
    },
  ];

  const isAdminRoute = pathName?.includes("/admin/");

  const isAppRoute =
    pathName?.includes("/apps/") ||
    pathName?.includes("/shared-with-me") ||
    pathName?.includes("/project/") ||
    pathName?.includes("/link/") ||
    pathName?.includes("/bundles");
  return (
    // Project Developer / Reviewer code
    <div
      style={{
        backgroundColor: "#fff",
        width: "100%",
        boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.1)",
        zIndex: 100,
        position: "sticky",
        top: 0,
      }}
    >
      <StyledAppBar
        sx={{
          width: "100%",
          backgroundColor: "#F6F8F9",
          borderBottom: "none !important",
          margin: "auto !important",
          position: "relative",
          zIndex: "50000 !important",
          pr: "0px",
          background: "transparent !important",
        }}
      >
        <Toolbar
          sx={{
            ...(!isTab ? { justifyContent: "flex-end" } : null),
            display: isTab ? "grid" : "flex",
            backgroundColor: "#fff",
            boxShadow: "none !important",
            borderColor: "#E8E8E8",
            // padding: isTab ? "0px 24px" : "0px 40px !important",
            padding: "0px 24px",
            "&.MuiPaper-root-MuiPopover-paper-MuiMenu-paper": {
              boxShadow: "none !important",
            },
            "&.MuiToolbar-root": {
              minHeight: "0 !important",
              height: "48px !important",
            },
          }}
        >
          <VeBox
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <VeBox sx={{ display: { md: "none" } }}>
              <IconButton
                aria-label="open drawer"
                edge={isMobile ? "start" : false}
                onClick={handleDrawerToggle}
              >
                <FontAwesomeIcon
                  icon={faBars}
                  style={{ fontSize: "20px", color: "#5f6368" }}
                />
              </IconButton>
            </VeBox>
            {!isTab && (
              <Link href="/" style={{ display: "flex" }}>
                <Image
                  width={currentRole === "SELLER" ? 135 : 79}
                  height={24}
                  src={currentRole === "SELLER" ? VE_SELLER : VE_TEXTICON}
                  alt="VE_ICON"
                />
              </Link>
            )}
            <VeBox
              sx={{
                paddingLeft: isMobile ? "0px" : "24px",
                marginRight: isMobile ? "unset" : "auto",
              }}
            >
              {currentRole === "SELLER" && isAdminRoute ? (
                <VeBox display={"flex"} alignItems={"center"} gap={"4px"}>
                  <VeBox
                    display={"flex"}
                    padding={"4px"}
                    borderRadius={"2.5px"}
                    bgcolor={"#E8E8E8"}
                  >
                    <SettingsIcon filledIcon={true} />
                  </VeBox>
                  <VeTypography variant="label2StrongSecondary">
                    Administration
                  </VeTypography>
                  {/* <Image src={SETTINGS} alt="profile" width={16} height={16} /> */}
                </VeBox>
              ) : currentRole === "SELLER" && isAppRoute ? (
                <VeBox display={"flex"} alignItems={"center"} gap={"8px"}>
                  <VeBox
                    display={"flex"}
                    padding={"4px"}
                    borderRadius={"2.5px"}
                    bgcolor={"#E8E8E8"}
                  >
                    <AppsIcon filledIcon={true} />
                  </VeBox>
                  <VeTypography variant="label2StrongSecondary">
                    Vericap Products
                  </VeTypography>
                </VeBox>
              ) : (
                !sellerDashBoardCondition &&
                currentRole === "SELLER" && <ProjectSelector />
              )}
            </VeBox>
            <VeBox sx={{ display: "flex", alignItems: "center" }}>
              {/* buttons */}
              {!isMobile && (
                <VeBox
                  display={"flex"}
                  alignItems={"center"}
                  paddingRight={"16px"}
                  marginRight={"16px"}
                  sx={{ borderRight: "1.5px solid #D5DBE1", gap: "16px" }}
                >
                  <a
                    href={`mailto:support@vericap.io?subject=Request for Support
`}
                    style={{ textDecoration: "none" }}
                  >
                    <IconButton sx={{ padding: "4px" }}>
                      <Image src={HELP} alt="HELP" width={20} height={20} />
                    </IconButton>
                  </a>
                  {currentRole === "SELLER" && <AppDropdown />}
                  <VeBox>
                    <SettingsDropdown />
                  </VeBox>
                  {/* <IconButton sx={{ position: "relative" }}> */}
                  {/* red dot icon if we have notifications, add some condition here for notification */}
                  {/* <Image
                      src={true ? BELL_ICON_ACTIVE : BELL_ICON}
                      alt="notification"
                      width={20}
                      height={20}
                    />
                  </IconButton> */}
                  {/* <NotificationPopup profileName={`${data?.user?.firstName} ${data?.user?.lastName}`}/> */}
                </VeBox>
              )}
              {/* {isTab ? (
                <VeBox
                  onClick={handleOpenUserMenuTab}
                  display="flex"
                  alignItems="center"
                >
                  <IconButton disableRipple sx={{ p: 0 }}>
                    <VeBox>
                      {data?.user?.profileImage ? (
                        <Image
                          src={`${process.env.NEXT_PUBLIC_CANNISTER_URL}/${data?.user?.profileImage}`}
                          alt="Profile"
                          width={32}
                          height={32}
                          style={{
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <ProfileIcon
                          name={`${data?.user?.firstName}`}
                          className="profile-user-icon"
                          color={data?.user?.profileColor}
                        />
                      )}
                    </VeBox>
                  </IconButton>
                </VeBox>
              ) : ( */}
              <VeBox
                onClick={handleOpenUserMenuTab}
                display="flex"
                alignItems="center"
              >
                <IconButton
                  onMouseEnter={() => setMenuHover(true)}
                  onMouseLeave={() => setMenuHover(false)}
                  sx={{
                    padding: "4px 8px",
                    borderRadius: "4px",
                    background: Boolean(anchorElUserTab) ? "#F3F3F3" : "",
                  }}
                >
                  <VeBox display="flex" gap={"6px"} alignItems={"center"}>
                    {data?.user?.profileImage ? (
                      <Image
                        src={`${process.env.NEXT_PUBLIC_CANNISTER_URL}/${data?.user?.profileImage}`}
                        alt="Profile"
                        width={24}
                        height={24}
                        style={{
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <ProfileIcon
                        // name={`${data?.user?.firstName} ${data?.user?.lastName}`}
                        name={`${data?.user?.firstName}`}
                        className="menu-profile-user-icon"
                        color={data?.user?.profileColor}
                      />
                    )}
                    {!isTab && (
                      <>
                        <LimiterToolTip
                          value={`${data?.user?.firstName} `}
                          variant={menuHover ? "label2Main" : "label2Secondary"}
                          limit={15}
                          width="auto"
                        />
                        <VeBox display={"flex"}>
                          <FontAwesomeIcon
                            icon={faChevronDown}
                            size="2xs"
                            style={{ color: "#8F9295", fontSize: "12px" }}
                          />
                        </VeBox>
                      </>
                    )}
                  </VeBox>
                </IconButton>
              </VeBox>
              {/* )} */}

              {/* rendering drawer or menu based on the screen size */}
              {isMobile ? (
                <Drawer
                  anchor="right"
                  open={anchorElUserTab}
                  onClose={handleCloseUserMenuTab}
                  PaperProps={{
                    sx: {
                      width: "100%",
                      maxWidth: "100%",
                      borderRadius: 0,
                      padding: 2,
                    },
                  }}
                >
                  <VeBox
                    display="flex"
                    alignItems={"center"}
                    gap={"8px"}
                    marginBottom={"16px"}
                  >
                    <IconButton onClick={handleCloseUserMenuTab}>
                      <FontAwesomeIcon
                        icon={faAngleLeft}
                        style={{ fontSize: "16px", color: "#5F6368" }}
                      />
                    </IconButton>
                    <VeTypography variant="label1StrongSecondary">
                      {data?.user?.firstName} {data?.user?.lastName}
                    </VeTypography>
                  </VeBox>
                  {/* <VeTypography
                    variant="label3Disabled"
                    sx={{ paddingLeft: "16px" }}
                  >
                    Switch Role
                  </VeTypography>
                  <RoleSelector
                    web={false}
                    insideMenu={true}
                    profileName={data?.user?.firstName}
                    handleCloseInsideUserMenuTab={handleCloseUserMenuTab}
                  /> */}
                  {/* horizontal row line */}
                  {/* <VeBox
                    sx={{ margin: "8px 0px" }}
                    border={"1px solid #E8E8E8"}
                  /> */}
                  <SettingsList settings={isTab ? tabSettings : settings} />
                </Drawer>
              ) : (
                <Menu
                  sx={{ mt: "32px" }}
                  id="menu-appbar"
                  disableScrollLock
                  anchorEl={anchorElUserTab}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  MenuListProps={{
                    disablePadding: true,
                  }}
                  slotProps={{
                    paper: {
                      sx: {
                        border: "1px solid #E8E8E8",
                        borderRadius: "8px",
                        padding: "8px",
                        // width: "300px",
                        boxShadow:
                          "0px 2px 16px 0px rgba(0, 0, 0, 0.08), 0px 2px 8px -2px rgba(0, 0, 0, 0.12)",
                      },
                    },
                  }}
                  open={Boolean(anchorElUserTab)}
                  onClose={handleCloseUserMenuTab}
                >
                  {/* {switchOrg ? (
                    <>
                      <MenuItem onClick={() => setSwitchOrg(false)}>
                        <VeBox
                          display={"flex"}
                          alignItems={"center"}
                          gap={"8px"}
                        >
                          <FontAwesomeIcon
                            icon={faAngleLeft}
                            style={{ marginLeft: "5px" }}
                            size="sm"
                          />
                          <VeTypography variant="label2StrongMain">
                            Switch to User
                          </VeTypography>
                        </VeBox>
                      </MenuItem>
                      <VeBox
                        sx={{ backgroundColor: "#E8E8E8", margin: "8px 16px" }}
                        height={"1px"}
                      />
                      <VeTypography
                        variant="label3Tertiary"
                        sx={{ paddingLeft: "16px" }}
                      >
                        Organisations
                      </VeTypography>
                      <OrgSelector
                        setSignInModal={setSignInModal}
                        setOrgChange={setOrgChange}
                        userOrgs={userOrgs}
                        setSwitchOrg={setSwitchOrg}
                        handleCloseInsideUserMenuTab={handleCloseUserMenuTab}
                      />
                      <VeBox sx={{ paddingLeft: "16px" }}>
                        <VeTypography variant="label3Tertiary">
                          *You have to enter your password again after switching
                          organisation.
                        </VeTypography>
                      </VeBox>
                    </>
                  ) : ( */}
                  <>
                    {/* <MenuItem
                        disableRipple
                        onClick={() => {
                          router.push("/setting-profile?section=0");
                          handleCloseUserMenuTab();
                          
                        }}
                      >
                        <VeBox
                          display={"flex"}
                          justifyContent={"space-between"}
                          // paddingX={"16px"}
                          width={"100%"}
                          alignItems={"center"}
                          sx={{ cursor: "pointer" }}
                        >
                          <VeBox
                            display="flex"
                            gap={"6px"}
                            alignItems={"center"}
                          >
                            {data?.user?.profileImage ? (
                              <Image
                                src={`${process.env.NEXT_PUBLIC_CANNISTER_URL}/${data?.user?.profileImage}`}
                                alt="Profile"
                                width={30}
                                height={30}
                                style={{
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                }}
                              />
                            ) : (
                              <ProfileIcon
                                // name={`${data?.user?.firstName} ${data?.user?.lastName}`}
                                name={`${data?.user?.firstName}`}
                                className="menu-profile-user-icon"
                                color={data?.user?.profileColor}
                                styles={{ width: "30px", height: "30px" }}
                                spanStyles={{ fontSize: "12px" }}
                              />
                            )}
                            <VeBox
                              display={"flex"}
                              alignItems={"start"}
                              // gap={"2px"}
                              justifyContent={"start"}
                              flexDirection={"column"}
                            >
                              <VeTypography variant={"label2StrongMain"}>
                                {`${data?.user?.firstName} ${data?.user?.lastName}`}
                              </VeTypography>
                              <VeTypography variant={"label3Secondary"}>
                                {limiter({
                                  strings: data?.user?.organisationName,
                                  limit: 20,
                                })}
                              </VeTypography>
                            </VeBox>
                          </VeBox>
                          <VeBox display={"flex"}>
                            <Image
                              src={RIGHT_ARROW_ICON}
                              alt="RIGHT_ARROW_ICON"
                            />
                          </VeBox>
                        </VeBox>
                      </MenuItem>
                      <VeBox
                        sx={{ backgroundColor: "#E8E8E8", margin: "8px 16px" }}
                        height={"1px"}
                      /> */}
                    {/* <VeTypography
                      variant="label3Disabled"
                      sx={{ paddingLeft: "16px" }}
                    >
                      Switch Role
                    </VeTypography>
                    <RoleSelector
                      web={false}
                      insideMenu={true}
                      profileName={data?.user?.firstName}
                      handleCloseInsideUserMenuTab={handleCloseUserMenuTab}
                    /> */}
                    {/* horizontal row line */}

                    <SettingsList settings={isTab ? tabSettings : settings} />
                  </>
                </Menu>
              )}
            </VeBox>
          </VeBox>
        </Toolbar>
      </StyledAppBar>
      {/* {signInModal && (
        <SignInModal
          open={signInModal}
          onClose={() => {
            setSignInModal(false);
            // Don't clear orgChange and loginData - they might be needed for MFA
          }}
          prefillEmail={prefillEmail}
          orgChange={orgChange}
          currentUserRole={
            data?.user?.lastLoggedInRole ||
            data?.user?.internalRoleName?.[0] ||
            data?.user?.internalRole?.[0]
          }
          onMfaRequired={(type, data) => {
            setLoginData(data);
            if (type === "SMS_MFA") {
              setSmsVerificationModal(true);
            } else if (type === "SOFTWARE_TOKEN_MFA") {
              setAuthenticatorVerificationModal(true);
            }
          }}
        />
      )}
      {smsVerificationModal && (
        <SmsVerificationModal
          open={smsVerificationModal}
          onClose={() => {
            setSmsVerificationModal(false);
            setOrgChange(null);
            setLoginData(null);
          }}
          loginData={loginData}
          orgChange={orgChange}
          currentUserRole={
            data?.user?.lastLoggedInRole ||
            data?.user?.internalRoleName?.[0] ||
            data?.user?.internalRole?.[0]
          }
        />
      )}
      {authenticatorVerificationModal && (
        <AuthenticatorVerificationModal
          open={authenticatorVerificationModal}
          onClose={() => {
            setAuthenticatorVerificationModal(false);
            setOrgChange(null);
            setLoginData(null);
          }}
          loginData={loginData}
          orgChange={orgChange}
          currentUserRole={
            data?.user?.lastLoggedInRole ||
            data?.user?.internalRoleName?.[0] ||
            data?.user?.internalRole?.[0]
          }
        />
      )} */}
      <SelectRoleModal
        open={selectRoleModal}
        onClose={() => setSelectRoleModal(false)}
        onSuccess={() => {
          // Optionally redirect or refresh after role change
          window.location.href = "/dashboard";
        }}
      />
    </div>
  );
}

const SettingsList = ({ settings }: any) => {
  const [expandedItems, setExpandedItems] = React.useState<{
    [key: string]: boolean;
  }>({});

  const toggleExpand = (name: string) => {
    setExpandedItems((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  return (
    <VeBox sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      {settings.map((setting: any, index: number) => {
        // Handle divider
        if (setting?.devider) {
          return (
            <VeBox
              key={`divider-${index}`}
              sx={{ backgroundColor: "#E8E8E8", margin: "0px 16px" }}
              height={"1px"}
            />
          );
        }

        // Handle items with nested dropdown
        if (setting?.items && Array.isArray(setting.items)) {
          const isExpanded = expandedItems[setting.name] || false;
          return (
            <VeBox key={setting?.name}>
              <MenuItem
                onClick={() => toggleExpand(setting.name)}
                sx={{
                  minWidth: "200px",
                  borderRadius: "4px",
                  width: "100%",
                }}
              >
                <VeBox
                  display="flex"
                  gap="8px"
                  alignItems="center"
                  justifyContent="space-between"
                  width="100%"
                >
                  <VeBox display="flex" gap="8px" alignItems="center">
                    <VeBox display="flex" alignItems="center">
                      {setting?.icon}
                    </VeBox>
                    <VeTypography variant="label2Main">
                      {setting?.name}
                    </VeTypography>
                  </VeBox>
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    style={{
                      fontSize: "12px",
                      color: "#8F9295",
                      transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.2s",
                    }}
                  />
                </VeBox>
              </MenuItem>
              {isExpanded && (
                <VeBox
                  sx={{ marginLeft: "24px", borderLeft: "1px solid #D5DBE1" }}
                >
                  {setting.items.map((item: any) => (
                    <MenuItem
                      key={item.label}
                      onClick={item.onClick}
                      sx={{
                        borderRadius: "4px",
                        minWidth: "184px",
                        padding: "8px 16px 8px 24px",
                      }}
                    >
                      <VeBox
                        display={"flex"}
                        justifyContent={"space-between"}
                        width={"100%"}
                        alignItems={"center"}
                      >
                        <VeTypography variant="label2Secondary">
                          {item.label}
                        </VeTypography>
                        {item?.newTab && (
                          <Image
                            src={LINK_GREY}
                            alt="redirect"
                            height={16}
                            width={16}
                            style={{ marginRight: "16px" }}
                          />
                        )}
                      </VeBox>
                    </MenuItem>
                  ))}
                </VeBox>
              )}
            </VeBox>
          );
        }

        // Handle regular menu item
        const menuItem = (
          <MenuItem
            key={setting?.name}
            onClick={setting?.onClick}
            sx={{
              minWidth: "200px",
              borderRadius: "4px",
              width: "100%",
            }}
          >
            <VeBox display="flex" gap="8px" alignItems="center">
              <VeBox display="flex" alignItems="center">
                {setting?.name === "Notification" ? (
                  <Image
                    src={BELL_ICON_ACTIVE}
                    alt="notification"
                    width={20}
                    height={20}
                  />
                ) : (
                  setting?.icon
                )}
              </VeBox>
              <VeTypography variant="label2Main">{setting?.name}</VeTypography>
            </VeBox>
          </MenuItem>
        );

        return setting?.href ? (
          <a
            key={setting?.name}
            href={setting.href}
            style={{ textDecoration: "none", color: "inherit" }}
            onClick={setting?.onClick}
          >
            {menuItem}
          </a>
        ) : (
          menuItem
        );
      })}
    </VeBox>
  );
};

export default AppBarUser;
